import { useMemo } from 'react';
import type { UsGameSport } from '@/lib/polymarketUs/sports';
import { useMarketStore } from '@/stores/marketStore';
import type { UsBrowserBoardQuote } from '@/stores/usBoardQuotes';

export interface UsBoardInput {
  sports: readonly UsGameSport[];
  pageVisible: boolean;
  sessionEpoch: number;
}

/** Public display quotes from the existing Hydra socket and store flush.
 * No catalogue polling, additional socket or account read. The native ticket
 * still obtains its own account, instrument and execution evidence. */
export function useUsBoardQuotes(input: UsBoardInput): ReadonlyMap<string, UsBrowserBoardQuote> | null {
  const version = useMarketStore(s => s.version);
  const sportsKey = [...input.sports].sort().join(',');
  return useMemo(() => {
    if (!input.pageVisible || !sportsKey) return null;
    const quotes = useMarketStore.getState().getUsBoardQuotes(sportsKey.split(',') as UsGameSport[]);
    return quotes.size ? quotes : null;
    // The mutable feed cache publishes through version; login changes also
    // discard the memo. Neither token is quote or account evidence.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [version, sportsKey, input.pageVisible, input.sessionEpoch]);
}
